module.exports = __webpack_public_path__ + "img/banner-32.6a935d9e.jpg";